import React from 'react';
import { Link } from 'react-router-dom';

import bgImg from '../../assets/img/bg/home-12.jpg';

const bgStyle = {
    backgroundImage:`url(${bgImg})`
}

const BannerHomeTwelve = () => {

    return (
        <React.Fragment>

            {/* <!-- banner section start --> */}
            <div className="rs-banner style8" style={bgStyle}>
                <div className="container">
                    <div className="banner-content text-center">
                        <span className="sub-title">Welcome to Swahili</span>
                        <h1 className="title text-light">Build Your<span> Dream </span>With Passion
                        </h1>
                        <ul className="banner-btn">
                            <li><Link className="readon started get-ready3" to="#">Get Started</Link></li>
                            <li><Link className="readon qoute-btn active" to="#">Discover More</Link></li>
                        </ul>
                        <div className="arrow-btn hidden-sm">
                            <a href="#rs-service">
                                <span className="up-down"></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- banner section end --> */}

        </React.Fragment>
    );
}

export default BannerHomeTwelve;